import React from "react";

const Education = () => {
  return (
    <section id="education" className="pt-16">
      <div className="mb-6">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-sky-600">
          Education
        </p>
        <h2 className="mt-2 text-2xl font-bold text-slate-950">
          Academic background
        </h2>
      </div>

      <article className="rounded-lg border border-slate-200 bg-white/70 p-5 shadow-sm">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h3 className="text-lg font-semibold text-slate-950">
              Master of Information Technology
            </h3>
            <p className="mt-1 text-sm text-slate-600">
              RMIT University, Melbourne
            </p>
          </div>
          <div className="flex flex-wrap gap-2 sm:justify-end">
            <span className="w-fit rounded-md border border-slate-200 bg-white px-3 py-1 text-sm font-semibold text-slate-700">
              2023 - 2024
            </span>
            <span className="w-fit rounded-md border border-slate-200 bg-white px-3 py-1 text-sm font-semibold text-slate-700">
              GPA: 3.8
            </span>
          </div>
        </div>

        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <div className="rounded-md border border-slate-200 bg-slate-50 px-4 py-3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
              Activities
            </p>
            <p className="mt-1 text-sm font-medium text-slate-700">
              Student Mentor
            </p>
          </div>
          <div className="rounded-md border border-slate-200 bg-slate-50 px-4 py-3">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
              Scholarship
            </p>
            <p className="mt-1 text-sm font-medium text-slate-700">
              Received RMIT's international student scholarship for academic
              performance
            </p>
          </div>
        </div>
      </article>
    </section>
  );
};

export default Education;
